export default __webpack_public_path__ + "static/media/dashboard_preview_4.01187206.png";